import React from 'react';
import ReactDOM from "react-dom";

// CONTAINERS
// import Layout from '../containers/Layout';
import FreebiePage from '../containers/FreebiePage';

document.addEventListener('DOMContentLoaded', () => {
  let server_data = {};
  const node = document.getElementById('server_data');
  if (node) {
    server_data = JSON.parse(node.getAttribute('data'));
  }

  ReactDOM.render(
    <FreebiePage server_data={server_data} />,
    document.getElementById("react-content"),
  )
});
